import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@lohi/environments/environment';
import { sort } from 'remeda';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService, LoHiUserInfo } from 'src/app/root/auth.service';
import { DriversService } from 'src/app/root/drivers.service';
import { ActiveDriver, PendingDriver } from 'src/app/types';
import { sortBy, sortByAlpha } from 'src/app/utilities/commonSorters';

type Sorter = (a: ActiveDriver, b: ActiveDriver) => number;

@Component({
  selector: 'lohi-drivers-list',
  templateUrl: './drivers-list.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriversListComponent implements OnInit {
  public activeDrivers$: Observable<ActiveDriver[]>;
  public pendingDrivers$: Observable<PendingDriver[]>;
  public inviteDriverUrl = environment.production
    ? 'https://carrier.lohi.ai/login'
    : 'https://carrier-dev.lohi.ai/login';
  public userInfo$: Observable<LoHiUserInfo>;

  constructor(
    private driverService: DriversService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  public sortBy: keyof ActiveDriver = 'driverName';
  public sortReverse = false;
  public sortingFunction$$ = new BehaviorSubject<Sorter>(getSortBy(this.sortBy, this.sortReverse));

  public ngOnInit(): void {
    this.userInfo$ = this.authService.userInfo$;
    this.activeDrivers$ = combineLatest([this.driverService.activeDriverList$, this.sortingFunction$$]).pipe(
      map(([drivers, sortFunc]) => sort(drivers, sortFunc)),
    );
    this.pendingDrivers$ = this.driverService.pendingDriverList$.pipe(
      map((drivers) => sort(drivers, sortByAlpha(['driverName']))),
    );
  }

  public setSortHeader(key: keyof ActiveDriver) {
    if (key === this.sortBy) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortBy = key;
      this.sortReverse = false;
    }
    this.sortingFunction$$.next(getSortBy(this.sortBy, this.sortReverse));
  }

  public navigateToProfile($event: MouseEvent, driverId: string) {
    $event.preventDefault();
    $event.stopPropagation();
    this.router.navigate(['../', driverId, 'profile'], { relativeTo: this.route });
  }
}

function getSortBy(key: keyof ActiveDriver, reverse: boolean): Sorter {
  const temp = sortBy(`${reverse ? '-' : ''}${key}`);
  return (a: ActiveDriver, b: ActiveDriver) => {
    return temp(a, b);
  };
}
